import { Component } from "solid-js";
import { InputProps } from "./input";

export type FormControlProps = {
  classList?: Record<string, boolean | undefined>;
  errors?: string[];
  label?: any;
  id?: string;
};

export const formControlProps = ["classList", "errors", "id", "label"] as const;
export type InputFormControl<
  Value,
  Type extends string,
  Extra = {}
> = Component<
  InputProps<
    Value,
    Type,
    {
      errors?: false | { message: string }[];
      label?: any;
    } & Extra
  >
>;
